// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__2Dzo4","title":"ClientInsurance_title__3ovsQ","itemText":"ClientInsurance_itemText__3a4iT"};